module.exports = __webpack_public_path__ + "static/media/teachersday.6a616be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupon/teachersday.png
// module id = 1299
// module chunks = 0